<div
	[ngClass]="searchbarExistsInHeader ? 'searchbar-group searchbar searchbar-header' : 'searchbar-group searchbar searchbar-site'"
	id="searchbarcontainer">
	<div class="input-group bg-transparent w-100 d-flex flex-row">
		<!-- Suchfeld -->
		<div class="input-group position-relative searchbar-group">
			<label for="searchbar" class="visuallyhidden">{{ placeholder }}</label>
			<input
				#searchbarInput
				type="text"
				(blur)="closeSuggestions()"
				autocomplete="off"
				[class.border-0]="!hasborder"
				class="form-control cursor-text typeahead searchbar-placeholder ms-0 searchbar-input"
				[class.header-input]="searchbarExistsInHeader"
				id="searchbar"
				[(ngModel)]="currentSearchWord"
				(ngModelChange)="changeSearchSuggestions($event)"
				(touchstart)="hasBlur(false)"
				(keydown)="onKeyDown($event)"
				[placeholder]="placeholder"
				(click)="changeSearchSuggestions(currentSearchWord)" />
			@if (suggestions) {
				<div
					class="position-absolute no-user-select bg-white w-100 input-menu"
					(touchstart)="hasBlur(false)"
					(mousedown)="hasBlur(false)"
					(mouseleave)="hasBlur(true)"
					style="top: 2.7rem">
					@if (suggestedCatalogs?.length === 0) {
						<div class="p-1 mx-1 border-bottom align-items-center d-flex">
							<div class="icon-default mask-settings info-mask-img bg-gray-500"></div>
							<div class="ms-1 hyphens text-gray-500">{{ 'searchbar.explicit-search-hint' | translate }}</div>
						</div>
					}
					@for (term of suggestedTerms; track term) {
						<div
							(click)="searchItem(term, false)"
							class="cursor-pointer one-line text-truncate d-block overflow-hidden"
							[ngClass]="term === indexedSearchterm ? 'bg-primary' : 'bg-gray-200-hover'">
							<div class="p-2 mx-1 one-line" [innerHtml]="term | searchhighlight: currentSearchTerm"></div>
						</div>
					}
					@if (suggestedCatalogs?.length > 0) {
						<div (mousedown)="$event.preventDefault()" class="px-2 py-1 mx-1 text-gray-600 border-top fw-semibold">
							{{ 'searchbar.catalog-suggestions' | translate }}
						</div>
					}
					@for (catalog of suggestedCatalogs; track catalog) {
						<a
							[attr.aria-description]="'catalog with key ' + catalog.key"
							(click)="navigateToCatalog()"
							draggable="false"
							class="text-decoration-none text-dark"
							[routerLink]="['/catalog', catalog.key]"
							data-toggle="list"
							role="tab">
							<div
								[ngClass]="catalog.key === indexedCatalogKey ? 'bg-primary' : 'bg-gray-200-hover bg-transparent'"
								class="d-flex px-2 py-1 img-holder-hovereffekt-wrapper">
								<div class="img-holder img-holder-hover ms-1 img-holder-small">
									<lib-catalog-logo-img
										[catalogKey]="catalog.key"
										[isSmall]="true"
										[alt]="catalog?.title"
										height="2.36rem"
										width="3.93rem"
										loading="lazy" />
								</div>
								<div class="ps-2 item-max-width">
									<div class="d-flex justify-content-between">
										<div class="one-line">
											<div [innerHtml]="catalog.title | searchhighlight: currentSearchTerm"></div>
										</div>
									</div>
									<div class="one-line text-small">
										<span>{{ getSearchCatalogCategories(catalog) }}</span>
									</div>
								</div>
							</div>
						</a>
					}
				</div>
			}

			<!-- Suchicon -->
			<div [class.startpage]="!searchbarExistsInHeader" class="search-button-container">
				<button
					class="btn btn-outline-dark search-button"
					aria-label="search-button"
					type="button"
					[class.border]="hasborder"
					[class.searchbar-rightinput]="hasborder"
					[class.on-top]="searchbarExistsInHeader"
					(click)="searchItem(currentSearchWord, true)"
					(mousedown)="hasBlur(false)">
					<div class="cursor-pointer bg-dark no-user-select mask-settings searchbar-action-mask-img"></div>
				</button>
			</div>
		</div>
	</div>
</div>
